<template>
  <PageHeader>
    <template #header-title>
      {{ $t('Insights') }}
    </template>
    <template v-if="props.hasEmbeddedInsights" #header-actions>
      <WdsSegmentedControl
        :options="[
          { optionKey: 'default', title: $t('Default Insights') },
          { optionKey: 'custom', title: $t('Custom Insights') },
        ]"
        :default-active-key="embeddedInsights ? 'custom' : 'default'"
        @click="changeInsightsVersion"
      />
    </template>
  </PageHeader>

  <slot v-if="!embeddedInsights" name="old-dashboard"></slot>
  <slot v-else name="new-dashboard"></slot>
</template>

<script setup lang="ts">
import { WdsSegmentedControl } from '@worksome/wds-components'
import { useLocalStorage } from '@vueuse/core'
import { $t } from '@/composables/translation'
import PageHeader from '@/components/PageHeader.vue'

const props = defineProps<{
  hasEmbeddedInsights: boolean
}>()
const embeddedInsights = useLocalStorage('useEmbeddedInsights', false)

if (!props.hasEmbeddedInsights) {
  embeddedInsights.value = false
}

const changeInsightsVersion = function (insights: 'custom' | 'default') {
  embeddedInsights.value = insights === 'custom'
}
</script>
